import { render, staticRenderFns } from "./SearchStatsOddsTable.vue?vue&type=template&id=2a571aee&scoped=true&"
import script from "./SearchStatsOddsTable.vue?vue&type=script&lang=js&"
export * from "./SearchStatsOddsTable.vue?vue&type=script&lang=js&"
import style0 from "./SearchStatsOddsTable.vue?vue&type=style&index=0&id=2a571aee&scoped=true&lang=css&"
import style1 from "./SearchStatsOddsTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a571aee",
  null
  
)

export default component.exports